module.exports = __webpack_public_path__ + "img/1546029661.cd061420.jpg";